import styled from 'styled-components';
import { rgba } from 'polished';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';

// CONSTANTS
import colors, { BLACK, SANTAS_GRAY, PORCELAIN, TRANSPARENT, WHITE } from '@/constants/colors';

export const CardStyled = styled(Card)`
  position: relative;
  overflow: visible;
  height: 100%;

  .package-card,
  &.package-card {
    padding: 40px 30px;
    border-radius: 6px;
    box-shadow: 0 10px 20px ${rgba(BLACK, 0.1)};
    border-width: 3px;
    border-style: solid;
    border-color: ${TRANSPARENT};

    &--active {
      border-color: ${colors.primary};
    }

    .title {
      transition: color 250ms ease;
    }

    .label {
      position: absolute;
      bottom: calc(100% - 2px);
      left: -3px;
      background-color: ${colors.primary};
      color: ${colors.primaryText};
      width: calc(100% + 6px);
      padding: 10px;
      border-radius: 6px 6px 0 0;
    }
  }
`;

export const PriceSection = styled.div`
  margin: 15px 0px 20px;
  line-height: 2.6rem;
  font-weight: 500;

  .price {
    font-size: 2.6rem;
  }

  .period {
    color: ${SANTAS_GRAY};
    font-size: 2rem;
  }
`;

export const DividerContainer = styled.div`
  max-width: 200px;
  width: 40%;
`;

export const AboutWrapper = styled.div`
  margin: 30px 0;
`;

export const ButtonStyled = styled(Button)`
  background-color: ${PORCELAIN};
`;

export const CollapseTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 30px;
  cursor: pointer;
  background: ${WHITE};
  min-height: 40px;
  position: relative;

  i {
    position: absolute;
    top: calc(50% - 7px);
    left: 0;
    font-size: 1.4rem;
    transform: rotate(0deg);
    transition: transform 0.4s;
  }

  &.details__title--open {
    i {
      transform: rotate(90deg);
    }
  }
`;

export default CardStyled;
